<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0 >
        
        <scroll-area>

          <template slot="header">

            <v-toolbar class="active" :height="44" flat dark>
              <v-toolbar-title>
                <span class="body-2 uppercase blacktext--text">{{ $t('push notifications') }}</span>
              </v-toolbar-title>

              <v-layout fill-height justify-end align-center>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'submit'"
                  @click="() => submit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'done'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('save') }}</span>
                </v-tooltip>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator"  
                  :data-testid="$options.name + '__btn__' + 'cancelEdit'"
                  @click="() => cancelEdit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('cancel') }}</span>
                </v-tooltip>

              </v-layout>

            </v-toolbar>

          </template>
          
          <template slot="body">

            <v-layout fill-height justify-start ma-0 pa-0 >

              <v-layout column fill-height justify-start ma-0 >

                <v-layout column shrink pt-1 ma-0>

                  <v-layout pa-0 pb-1>
                    <v-flex xs6  pa-0>
                      <v-text-field    
                        :value="$t('message')"                 
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'message'"
                        v-model="model.obj['message']"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout pa-0  pb-1>

                    <v-flex xs6  pa-0>
                            
                      <v-text-field
                        :value="$t('users')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs12  px-0 pb-2>

                      <v-select
                        :data-testid="$options.name + '__select__' + 'names'"
                        v-model="model.obj['names']"
                        :items="getUsers"
                        hide-details
                        item-text="name"
                        item-value="name"
                        outline
                        multiple
                        clearable
                        fill-width
                        clear-icon="clear"
                        background-color="backgrey"
                        :style="'width: -webkit-fill-available'"
                      >
                        
                      </v-select>

                    </v-flex>

                  </v-layout>
                </v-layout>

                <v-tooltip v-if="!edit" dark color="secondary" right>                
                  <v-btn flat class="primary" slot="activator" outline small 
                  :disabled="!model.obj.message || !model.obj.names.length"
                  :data-testid="$options.name + '__btn__' + 'submit'"
                  @click="() => submit()">
                    <span class="primary--text">{{ $t('send') }}</span>
                  </v-btn>
                  <span>{{ $t('send push-notification') }}</span>
                </v-tooltip>

              </v-layout>
              
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface UserItem {
  $id?: string
  id?: string
  name?: string
  [key: string]: any
}

interface ModelObj {
  service: string
  names: string[]
  message: string
  [key: string]: any
}

interface ModelData {
  obj: ModelObj
  fields: Record<string, any>
}

interface CmdbQueryResponse {
  children?: UserItem[]
  [key: string]: any
}

interface NotificationResponse {
  [key: string]: any
}

export default Vue.extend({
  name: 'PUSH_NOTIFICATIONS',

  components: {
    scrollArea,
    svgIcon,
  },

  props: {},

  data(): {
    meta: any | null
    data: any | null
    edit: boolean
    users: UserItem[]
    model: ModelData
  } {
    return {
      meta: null,
      data: null,
      edit: false,
      users: [],
      model: {
        obj: {
          service: 'e-core',
          names: [],
          message: 'test',
        },
        fields: {}
      },
    }
  },

  computed: {
    getData(): any | null {
      return this.data
    },

    getObj(): ModelObj {
      return this.model.obj
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getUsers(): UserItem[] {
      return this.users
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadUsers()
    },

    async loadUsers(): Promise<void> {
      try {
        // const query = {
        //   id: ['/catalogs/user'],
        //   data: {
        //     namePath: true,
        //     children: { flatten: true }
        //   }
        // }
        // const users = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        // if (users?.[0]) {
        //   this.users = users[0].children || []
        // }
        const users = await this.$bridge.getAllUsers()
        this.users = users || []
      } catch (error) {
        console.error(this.$options.name, 'loadUsers smth wrong', error)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async cancelEdit(): Promise<void> {
      this.edit = false
      await this.setup()
    },

    async submit(): Promise<void> {
      console.log(this.$options.name, 'submit', 'START', this.getObj)
      try {
        this.setLoader('submit', true)
        const u = await this.$bridge.customQuery('core', 'notification/send', this.getObj, 'post') as NotificationResponse
        console.log(this.$options.name, 'submit', 'success', u)
        this.setLoader('submit', false)
        this.$dialog.notify.success('Push-уведомление успешно отправлено', { timeout: 5000 })
        this.edit = false
        await this.setup()
      } catch (error) {
        console.error(this.$options.name, 'submit smth wrong', error)
        this.setLoader('submit', false)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
